import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Forgot Username request is successful.
 * @memberOf Playtech.API.events
 * @event FORGOT_USERNAME_SUCCESS
 * @type {callback}
 * @example Playtech.on('FORGOT_USERNAME_SUCCESS', () => { ... });
 */
export const EVENT_FORGOT_USERNAME_SUCCESS = 'FORGOT_USERNAME_SUCCESS';
/**
 * Event fires when Forgot Username request is failed.
 * @memberOf Playtech.API.events
 * @event FORGOT_USERNAME_FAIL
 * @type {callback}
 * @example Playtech.on('FORGOT_USERNAME_FAIL', () => { ... });
 */
export const EVENT_FORGOT_USERNAME_FAIL = 'FORGOT_USERNAME_FAIL';

export const useOnForgotUsername = (eventTarget: EventTarget) => {
    const eventNameSuccess = 'forgotUsername:success';
    const eventNameFail = 'forgotUsername:fail';

    const handleEvent = useCallback((eventName: string): void => {
        const event = eventName === eventNameSuccess
            ? new CustomEvent(EVENT_FORGOT_USERNAME_SUCCESS)
            : new CustomEvent(EVENT_FORGOT_USERNAME_FAIL);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(eventNameSuccess, () => handleEvent(eventNameSuccess));
        publicEventsAPIService.on(eventNameFail, () => handleEvent(eventNameFail));

        return () => {
            publicEventsAPIService.off(eventNameSuccess, handleEvent);
            publicEventsAPIService.off(eventNameFail, handleEvent);
        };
    }, [handleEvent]);
};
